import { defineStore } from 'pinia'
import { ref } from 'vue'
import {
  appConfigApi,
  APP_CONFIG_TYPE,
  APP_PC_BASIC_CONF_CODE,
  type AppPcBasicConfig,
} from '@/api/appConfig'

const emptyConfig = (): AppPcBasicConfig => ({
  userGuideUrl: '',
  sideBarMoreMenu: [],
  account_cancel_label: '',
  account_cancel_countdown: 0,
})

const normalizeConfig = (value: unknown): AppPcBasicConfig => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return emptyConfig()
  }
  const raw = value as AppPcBasicConfig
  const countdown = raw.account_cancel_countdown
  return {
    userGuideUrl: typeof raw.userGuideUrl === 'string' ? raw.userGuideUrl : '',
    sideBarMoreMenu: Array.isArray(raw.sideBarMoreMenu) ? raw.sideBarMoreMenu : [],
    account_cancel_label:
      typeof raw.account_cancel_label === 'string' ? raw.account_cancel_label : '',
    account_cancel_countdown:
      typeof countdown === 'number' && Number.isFinite(countdown) ? Math.trunc(countdown) : 0,
  }
}

export const useAppBasicConfigStore = defineStore('appBasicConfig', () => {
  const config = ref<AppPcBasicConfig>(emptyConfig())

  let inflight: Promise<boolean> | null = null

  const reset = () => {
    inflight = null
    config.value = emptyConfig()
  }

  /** 拉取 PC 应用基础配置，可供任意地方调用 */
  const fetchConfig = async (): Promise<boolean> => {
    if (inflight) {
      return inflight
    }

    inflight = (async () => {
      try {
        const res = await appConfigApi.query<AppPcBasicConfig>({
          type_code: APP_PC_BASIC_CONF_CODE,
          config_type: APP_CONFIG_TYPE,
        })
        if (res?.code !== 0 || !res.data) {
          console.error('[appBasicConfigStore] 查询应用配置失败:', res?.message)
          return false
        }
        config.value = normalizeConfig(res.data.config)
        return true
      } catch (error) {
        console.error('[appBasicConfigStore] 查询应用配置失败:', error)
        return false
      } finally {
        inflight = null
      }
    })()

    return inflight
  }

  return {
    config,
    fetchConfig,
    reset,
  }
})
